import { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';

import { useFeedContext } from '../components/shared/FeedContext';

import { UPDATE_NUM_ENTRIES } from '../components/shared/feed.actions';
import { roundUpNearest10 } from '../utils';

const useFeedIntersectionObserver = ({ index, isParentFeedEntry }) => {
  // intersectionObserverRef is a tag placed on any feed entry to keep track of
  // its inView status
  const [intersectionObserverRef, inView] = useInView({
    threshold: 0.5 // same as android (50%)
  });

  const { dispatch: dispatchFeed } = useFeedContext() || { dispatch: () => {} }; // TODO remove dummy dispatch for feed without container

  useEffect(() => {
    if (isParentFeedEntry && inView) {
      dispatchFeed({
        type: UPDATE_NUM_ENTRIES,
        payload: { numEntries: roundUpNearest10(index) } // fetches extra rows on page load for scroll restoration
      });
    }
  }, [dispatchFeed, inView, index, isParentFeedEntry]);

  return {
    inView,
    intersectionObserverRef
  };
};

export default useFeedIntersectionObserver;
